import React from 'react';
import { CONCURRENCY_CHOICES, CONCURRENCY_LABELS } from './powerDialConstants.js';

export default function ConcurrencySelector({ concurrency, setConcurrency, effectiveLeadCount }) {
  return (
    <div className="mb-4">
      <div className="flex items-center justify-between mb-2">
        <label htmlFor="pd-concurrency" className="block text-xs uppercase tracking-wider text-white/60 font-semibold">
          Parallel Lines
        </label>
        {effectiveLeadCount < 5 && (
          <span className="text-[10px] text-white/40">
            (Capped at {effectiveLeadCount} {effectiveLeadCount === 1 ? 'selected lead' : 'selected leads'})
          </span>
        )}
      </div>
      <select
        id="pd-concurrency"
        value={concurrency}
        onChange={(e) => setConcurrency(Number(e.target.value))}
        className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-sm text-white focus:border-civix-purple outline-none"
      >
        {CONCURRENCY_CHOICES.map((n) => (
          <option key={n} value={n} disabled={n > effectiveLeadCount} className="bg-[#0F0E17]">
            {CONCURRENCY_LABELS[n]}
          </option>
        ))}
      </select>
    </div>
  );
}
